import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Intelligent_recognition",
  "use": "icon-Intelligent_recognition-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Intelligent_recognition\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8,2V4H4V8H2V2.67A.67.67,0,0,1,2.67,2ZM21.33,2a.67.67,0,0,1,.67.67V8H20V4H16V2ZM16,6.8v2H13v8H11v-8H8v-2ZM4,16v4H8v2H2.67A.67.67,0,0,1,2,21.33V16Zm18,0v5.33a.67.67,0,0,1-.67.67H16V20h4V16Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol